import { routeName as routeNameLogin } from "../screens/onboarding/login/LoginScreen";
import { routeName as routeNameSplash } from "../screens/onboarding/splash/SplashScreen";
import { routeName as routeNameHome } from "../screens/home/HomeScreen";
import { routeName as routeNameSettings } from "../screens/settings/settings/SettingsScreen";
import { routeName as routeNameChats } from "../screens/chats/chats/ChatsScreen";
import { routeName as routeNameNotices } from "../screens/notices/notices_list/NoticesListScreen";
import { routeName as routeNameNoticesDetail } from "../screens/notices/notices_detail/NoticesDetailScreen";
import { routeName as routeNameNoticesFollowing } from "../screens/notices/following_list/FollowingListScreen";
import { routeName as routeNameSearch } from "../screens/search/SearchScreen";
import { routeName as routeNameNotFound } from "../screens/not_found/NotFoundScreen";
import { routeName as routeNameProducts } from "../screens/products/ProductsScreen";
import { routeName as routeNameEmail } from "../screens/email/EmailScreen";
import { routeName as routeNameBranchDeptChats } from "../screens/branch/branch_dept_chats/BranchDeptChatsScreen";
import { routeName as routeNameBranchTeam } from "../screens/branch/branch_team/BranchTeamScreen";
import { routeName as routeNameBranchGroups } from "../screens/branch/branch_groups/BranchGroupsScreen";
import { routeName as routeNameSettingsChangeDefaultBranch } from "../screens/settings/change_default_branch/SettingsChangeDefaultBranchScreen";
import { routeName as routeNameBranchFollowGroup } from "../screens/branch/branch_follow_groups/BranchFollowGroupsScreen";
import { routeName as routeNamePreviewImageDocs } from "../screens/preview/image_document_preview/ImageDocumentPreviewScreen";
import { routeName as routeNameSettingsPeronalInfo } from "../screens/settings/manage_personal_profile/SettingsPersonalInfoScreen";
import { routeName as routeNameSettingsDeactivateAccountAlert } from "../screens/deactivate_account/deactivate_account_password_alert/DeactivateAccountScreen";
import { routeName as routeNameSettingsDeactivateAccountReason } from "../screens/deactivate_account/deactivate_account_reason/DeactivateAccountReasonScreen";
import {
  routeNamePassword as routeNameSettingsPersonalSecurityPassword,
  routeNameEmail as routeNameSettingsPersonalSecurityEmail,
  routeNamePhone as routeNameSettingsPersonalSecurityPhone,
} from "../screens/settings/security/personal_security/SettingsPersonalSecurityScreen";
import { routeName as routeNameNewPassword } from "../screens/onboarding/forgot_password/new_password/NewPasswordScreen";
import { routeName as routeNameRecoverPassword } from "../screens/onboarding/forgot_password/recover_password/RecoverPasswordScreen";
import { routeName as routeNameSettingsAccountVerification } from "../screens/settings/security/account_verification/SettingsAccountVericationScreen";
import { routeName as routeNameSignupThirdParty } from "../screens/onboarding/signup/third_party_selection/SignupThirdPartyScreen";
import { routeName as routeNameSignupPersonalInfo } from "../screens/onboarding/signup/personal_information/SignupPersonalInformationScreen";
import {
  routeName as routeNameSignupVerification,
  routeNameForgotPasswordVerification,
} from "../screens/onboarding/signup/account_verification/SignupAccountVerificationScreen";

import { routeName as routeNameSignupVerificationChange } from "../screens/onboarding/signup/account_verification_change/SignupAccountVerificationChangeScreen";
import { routeName as routeNameSignupUploadLogo } from "../screens/onboarding/signup/personal_logo_upload/SignupPersonalLogoUploadScreen";
import { routeName as routeNameHomeGuest } from "../screens/home_guest_user/guest_home/HomeGuestUserScreen";
import {
  routeNameFormGeneral as routeNameGuestFormGeneral,
  routeNameFormFeedback as routeNameGuestFormFeedback,
} from "../screens/home_guest_user/guest_user_form/GuestUserFormScreen";
import { routeName as routeNameBoarding } from "../screens/onboarding/boarding/BoardingScreen";
import { routeName as routeNameChatTeam } from "../screens/chats/team_chat/TeamChatScreen";
import { routeName as routeNameChatDepartment } from "../screens/chats/department_chat/DepartmentChatScreen";
import { routeName as routeNameChatGroup } from "../screens/chats/group_chat/GroupChatScreen";
import { routeName as routeNameBranchSwitchSplash } from "../screens/branch/branch_switch_flash/BranchSwitchSplashScreen";

const segments = window.location.pathname.split("/").filter(Boolean);
const URL_PREFIX = `/${segments[0]}`; // `/:code`;

export const appRoutes = {
  routeNameNotFound: `${URL_PREFIX}${routeNameNotFound}`,
  routeNameBoarding: `${routeNameBoarding}`,
  routeNameBoardingSplash: `${URL_PREFIX}`,
  routeNameSplash: `${URL_PREFIX}${routeNameSplash}`,
  routeNameLogin: `${URL_PREFIX}${routeNameLogin}`,

  routeNameSignupThirdParty: `${URL_PREFIX}${routeNameSignupThirdParty}`,
  routeNameSignupPersonalInfo: `${URL_PREFIX}${routeNameSignupPersonalInfo}`,
  routeNameSignupVerification: `${URL_PREFIX}${routeNameSignupVerification}`,
  routeNameSignupVerificationChange: `${URL_PREFIX}${routeNameSignupVerificationChange}`,
  routeNameSignupUploadLogo: `${URL_PREFIX}${routeNameSignupUploadLogo}`,

  routeNameHomeGuest: `${URL_PREFIX}${routeNameHomeGuest}`,
  routeNameGuestFormGeneral: `${URL_PREFIX}${routeNameGuestFormGeneral}`,
  routeNameGuestFormFeedback: `${URL_PREFIX}${routeNameGuestFormFeedback}`,

  routeNameHome: `${URL_PREFIX}${routeNameHome}`,
  routeNameSettings: `${URL_PREFIX}${routeNameSettings}`,
  routeNameChats: `${URL_PREFIX}${routeNameChats}`,
  routeNameNotices: `${URL_PREFIX}${routeNameNotices}`,
  routeNameNoticesDetail: `${URL_PREFIX}${routeNameNoticesDetail}`,
  routeNameNoticesFollowing: `${URL_PREFIX}${routeNameNoticesFollowing}`,
  routeNameSearch: `${URL_PREFIX}${routeNameSearch}`,
  routeNameProducts: `${URL_PREFIX}${routeNameProducts}`,
  routeNameEmail: `${URL_PREFIX}${routeNameEmail}`,
  routeNameBranchDeptChats: `${URL_PREFIX}${routeNameBranchDeptChats}`,
  routeNameBranchTeam: `${URL_PREFIX}${routeNameBranchTeam}`,
  routeNameBranchGroups: `${URL_PREFIX}${routeNameBranchGroups}`,
  routeNameSettingsChangeDefaultBranch: `${URL_PREFIX}${routeNameSettingsChangeDefaultBranch}`,
  routeNameBranchFollowGroup: `${URL_PREFIX}${routeNameBranchFollowGroup}`,
  routeNamePreviewImageDocs: `${URL_PREFIX}${routeNamePreviewImageDocs}`,
  routeNameSettingsPeronalInfo: `${URL_PREFIX}${routeNameSettingsPeronalInfo}`,
  routeNameSettingsDeactivateAccountAlert: `${URL_PREFIX}${routeNameSettingsDeactivateAccountAlert}`,
  routeNameSettingsDeactivateAccountReason: `${URL_PREFIX}${routeNameSettingsDeactivateAccountReason}`,
  routeNameSettingsPersonalSecurityPassword: `${URL_PREFIX}${routeNameSettingsPersonalSecurityPassword}`,
  routeNameSettingsPersonalSecurityEmail: `${URL_PREFIX}${routeNameSettingsPersonalSecurityEmail}`,
  routeNameSettingsPersonalSecurityPhone: `${URL_PREFIX}${routeNameSettingsPersonalSecurityPhone}`,
  routeNameNewPassword: `${URL_PREFIX}${routeNameNewPassword}`,
  routeNameRecoverPassword: `${URL_PREFIX}${routeNameRecoverPassword}`,
  routeNameSettingsAccountVerification: `${URL_PREFIX}${routeNameSettingsAccountVerification}`,

  routeNameChatTeam: `${URL_PREFIX}${routeNameChatTeam}`,
  routeNameChatDepartment: `${URL_PREFIX}${routeNameChatDepartment}`,
  routeNameChatGroup: `${URL_PREFIX}${routeNameChatGroup}`,

  routeNameForgotPasswordVerification: `${URL_PREFIX}${routeNameForgotPasswordVerification}`,
  routeNameBranchSwitchSplash: `${URL_PREFIX}${routeNameBranchSwitchSplash}`,
};
